<template>

  <svg
    t="1641142308318"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4027"
    width="64"
    height="64"
  ><path d="M876.08888853 557.51111147L557.51111147 557.51111147l0 318.57777813c0 25.03111147-20.48 45.51111147-45.51111147 45.51111147s-45.51111147-20.48-45.51111147-45.51111147L466.48888853 557.51111147 147.91111147 557.51111147c-25.03111147 0-45.51111147-20.48-45.51111147-45.51111147 0-25.03111147 20.48-45.51111147 45.51111147-45.51111147l318.57777813 0L466.48888853 147.91111147c0-25.03111147 20.48-45.51111147 45.51111147-45.51111147s45.51111147 20.48 45.51111147 45.51111147l0 318.57777813 318.57777813 0c25.03111147 0 45.51111147 20.48 45.51111147 45.51111147C921.6 537.03111147 901.12 557.51111147 876.08888853 557.51111147z" p-id="4028" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconPlus',
} as DefineComponent
</script>